export const keyById = <T, K extends string | number>(
  items: T[],
  getKey: (item: T) => K,
): Record<K, T> =>
  items.reduce(
    (acc, item) => {
      acc[getKey(item)] = item;
      return acc;
    },
    {} as Record<K, T>,
  );
